module.exports = __webpack_public_path__ + "static/fonts/Roboto-Black.5ebb24ee.ttf";